module.exports = __webpack_public_path__ + "img/woocommerce.9bcea9b.svg";